<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>法律服务</el-breadcrumb-item>
        <el-breadcrumb-item>栏目与内容</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="pageWrapper" v-loading="dataLoading">
      <div class="leftWrapper">
        <!-- 栏目树形列表 -->
        <el-card class="cardWrapper" shadow="never">
          <div slot="header" class="header">
            <span class="title">栏目列表</span>
            <div class="btns">
              <el-button size="mini" @click="handleRefresh()">刷新</el-button>
              <el-button size="mini" type="success" @click="handleAppend()">添加顶级栏目</el-button>
            </div>
          </div>
          <el-tree
            lazy
            node-key="id"
            class="treeWrapper"
            ref="treeWrapperRef"
            :props="{ label: 'name', children: 'children', isLeaf: 'isLeaf' }"
            :data="treeColumnData"
            :load="loadColumnData"
            :expand-on-click-node="false"
            :highlight-current="true"
            @node-click="handleNodeClick"
          >
            <div slot-scope="{ data }" class="nodeWrapper">
              <div class="title">{{ data.name }}</div>
              <el-button circle size="mini" type="success" @click.stop="handleAppend(data)" icon="el-icon-plus" title="添加子栏目" />
              <el-button circle size="mini" type="primary" @click.stop="handleEdit(data)" icon="el-icon-edit" title="编辑栏目" />
              <el-button circle size="mini" type="danger" @click.stop="handleDelete(data)" icon="el-icon-delete" title="删除栏目" />
            </div>
          </el-tree>
        </el-card>
      </div>

      <div class="mainWrapper">
        <!-- 栏目节点表单 -->
        <el-card class="cardWrapper" shadow="never" v-if="formVisible">
          <div slot="header">
            <span>栏目节点信息</span>
          </div>
          <el-form :model="formParams" label-width="100px" :rules="checkListParams">
            <el-form-item label="父级栏目：" v-if="formParams.parentId">{{ formParams.parentName }}</el-form-item>
            <el-form-item label="栏目类型：">
              <el-radio-group v-model="formParams.type">
                <el-radio :label="4">列表项一</el-radio>
                <el-radio :label="5">列表项二</el-radio>
                <el-radio :label="6">列表项三</el-radio>
                <el-radio :label="1">列表</el-radio>
                <el-radio :label="2">电话</el-radio>
                <el-radio :label="3">内容项</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="栏目名称：">
              <el-input v-model="formParams.name" placeholder="请输入栏目名称" :maxlength="100" show-word-limit />
            </el-form-item>
            <el-form-item label="栏目内容：" v-if="[2, 3].includes(formParams.type)">
              <el-input v-if="formParams.type == 2" v-model="formParams.content" placeholder="请输入电话" :maxlength="20" show-word-limit />
              <RichTextarea v-else-if="formParams.type == 3" v-model="formParams.content" class="wang-editor-style" height="300px" />
            </el-form-item>
            <el-form-item label="栏目排序：">
              <el-input-number v-model="formParams.sortNumber" placeholder="请输入栏目排序" :min="0" :max="9999" />
            </el-form-item>
            <el-form-item label="栏目状态：">
              <el-switch v-model="formParams.status" :active-value="1" :inactive-value="2" active-text="上架" inactive-text="下架" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm">确认保存</el-button>
              <!-- <el-button @click="resetForm">重置</el-button> -->
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

const defaultParams = {
  id: "",
  parentId: "",
  parentName: "",
  name: "",
  type: 4,
  content: "",
  sortNumber: 1,
  status: 1,
};

const loadNodeResolveMap = new Map();

export default {
  data() {
    return {
      dataLoading: false,
      treeColumnData: [],
      formParams: { ...defaultParams },
      checkListParams: {
        // name: [{ required: true, message: "请输入栏目标题", trigger: "blur" }],
        // content: [{ required: true, message: "请输入栏目内容", trigger: "blur" }]
      },
      formVisible: false,
    };
  },

  methods: {
    /**
     * 刷新
     * @param parentId
     */
    handleRefresh(parentId) {
      if (parentId) {
        // const { node, resolve } = loadNodeResolveMap.get(parentId);
        // this.loadColumnData(node, resolve);
        const node = this.$refs.treeWrapperRef.getNode(`${parentId}`);
        node.loaded = false;
        node.loadData();
      } else {
        this.treeColumnData = [];
        const { node, resolve } = loadNodeResolveMap.get("root");
        this.loadColumnData(node, resolve);
      }
    },

    /**
     * 加载栏目数据
     * @param node
     * @param resolve
     */
    async loadColumnData(node, resolve) {
      const params = {};
      const data = node.data || {};
      if (node.level === 0) {
        params.parentId = "";
        loadNodeResolveMap.set("root", { node, resolve });
      } else {
        params.parentId = data.id;
        loadNodeResolveMap.set(data.id, { node, resolve });
      }
      try {
        const response = await Vue.ajaxGet(this, global.apiUrl + "/law/help/list", params, "dataLoading");
        resolve((response || []).map(item => ({ ...item, parentId: data.id || "", parentName: data.name || "" })));
      } catch (error) {
        console.error(error);
        resolve([]);
      }
    },

    /**
     * 节点点击事件
     * @param data
     */
    handleNodeClick(data) {
      this.formParams = { ...data };
      this.formVisible = true;
    },

    /**
     * 添加节点
     * @param data
     */
    handleAppend(data) {
      this.formParams = { ...defaultParams };
      if (data) {
        this.formParams.parentId = data.id;
        this.formParams.parentName = data.name;
      }
      this.formVisible = true;
    },

    /**
     * 编辑节点
     * @param data
     */
    handleEdit(data) {
      this.formParams = { ...data };
      this.formVisible = true;
    },

    /**
     * 删除节点
     * @param data
     */
    handleDelete(data) {
      this.$confirm("确定要删除该节点吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            await Vue.ajaxPut(this, global.apiUrl + "/law/help/delete", { id: data.id }, "dataLoading");
            this.handleRefresh(data.parentId);
            this.$message.success("删除成功");
          } catch (error) {
            console.error(error);
          }
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },

    /**
     * 提交表单
     */
    async submitForm() {
      const data = { ...this.formParams };
      if (data.type == 1) {
        if (!data.name) {
          this.$message.error("请输入栏目名称");
          return;
        }
      }
      try {
        if (data.id) {
          await Vue.ajaxPut(this, global.apiUrl + "/law/help/update", data, "dataLoading");
        } else {
          await Vue.ajaxPost(this, global.apiUrl + "/law/help/add", data, "dataLoading");
        }
        this.handleRefresh(data.parentId);
        this.$message.success("操作成功");
        this.resetForm();
      } catch (error) {
        console.error(error);
      }
    },

    /**
     * 重置表单
     */
    resetForm() {
      this.formParams = { ...defaultParams };
      this.formVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .pageWrapper {
    display: flex;
    justify-content: space-between;
    .leftWrapper {
      width: 400px;
      .nodeWrapper {
        width: calc(100% - 24px);
        height: 36px;
        display: flex;
        align-items: center;
        .title {
          flex: 1;
          font-size: 16px;
          color: #333;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
    .mainWrapper {
      width: calc(100% - 410px);
      :deep(.el-radio) {
        width: 100px;
        line-height: 24px;
      }
    }

    .cardWrapper {
      .header {
        display: flex;
        align-items: center;
        .title {
          flex: 1;
        }
      }
    }
  }
}
.treeWrapper {
  max-height: 78vh;
  overflow-y: auto;
  :deep(.el-tree-node__content) {
    height: auto;
  }
}
.wang-editor-style {
  padding: 0;
}
</style>
